import { ReactElement } from 'react';
import FormGroup from '~/components/form/FormGroup';
import { FormHorizontal } from '~/components/form/layout';
import ValibotFieldInput from '~/components/valibot/ValibotFieldInput';

export default function BreTwilightSubmit(): ReactElement {
  return (
    <FormGroup>
      <FormHorizontal name="editing_credits" label="Editing Credits">
        <ValibotFieldInput name="editing_credits" type="number" />
      </FormHorizontal>
    </FormGroup>
  );
}
